import { render, staticRenderFns } from "./SubstepTextCard.vue?vue&type=template&id=f4575a82&"
import script from "./SubstepTextCard.vue?vue&type=script&lang=js&"
export * from "./SubstepTextCard.vue?vue&type=script&lang=js&"
import style0 from "./SubstepTextCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports